export type AudioCapabilities = {
  readonly contextSink: boolean
  readonly mediaElementSink: boolean
  readonly outputPicker: boolean
}

export type RoutingStrategy =
  | { readonly kind: "audio_context"; readonly canPrompt: boolean }
  | { readonly kind: "media_element"; readonly canPrompt: boolean }
  | { readonly kind: "system_default"; readonly canPrompt: false }

export function chooseRoutingStrategy(capabilities: AudioCapabilities): RoutingStrategy {
  if (capabilities.contextSink) {
    return { kind: "audio_context", canPrompt: capabilities.outputPicker }
  }
  if (capabilities.mediaElementSink) {
    return { kind: "media_element", canPrompt: capabilities.outputPicker }
  }
  return { kind: "system_default", canPrompt: false }
}
